module.exports = __webpack_public_path__ + "img/radio-station.eff62d80.webp";